import { render } from "./BestInAttendanceModal.vue?vue&type=template&id=0a9b781b"
import script from "./BestInAttendanceModal.vue?vue&type=script&lang=js"
export * from "./BestInAttendanceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__